import { CardContent } from '@mui/material';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import React, { useEffect } from 'react';
import useWebContext from '../../hooks/useWebContext';
import { MyMImage } from '../../ui-elements/MyMImage';
import { OutlinedCustomCard } from '../../ui-parts/OutlinedCustomCard';
import { HomeCenterHeader } from "./HomeUtils";


/** MyMine Version1.5 新規追加
* Home Latest HCM Social Post Card
*/
export const HomeLatestHcmSocialPostsCard = () => {
  const screenId = 'MyM102';
  const { controlSettings } = useWebContext(screenId);

  return (
    <OutlinedCustomCard sx={{ display: 'flex', flexDirection: 'column', height: '369px' }}>
      <HomeCenterHeader title={
        <>
          {controlSettings.LabelList.lblSocialPostsTitle}
          <Link href='https://x.com/hitachicm_en/' target='_blank' sx={{ paddingLeft: '25px' }}>
            <MyMImage screenId={screenId} filePath={controlSettings.ImageList.imgTwitterIcon1} width='25px' height='25px' />
          </Link>          
          <Link href='https://www.youtube.com/@HCMchannel/featured' target='_blank' sx={{ paddingLeft: '25px' }}>
            <MyMImage screenId={screenId} filePath={controlSettings.ImageList.imgYoutubeIcon3} width='25px' height='25px' />
          </Link>
        </>
      } />
      <CardContent sx={{ height: "320px", overflowY: "auto" }}>
        <EmbedSocialPosts />
      </CardContent>
    </OutlinedCustomCard>

  )
}


const EmbedSocialPosts = () => {
  useEffect(() => {
    const scriptId = 'EmbedSocialHashtagScript';
    const script = document.createElement('script');
    script.id = scriptId;
    script.src = 'https://embedsocial.com/cdn/ht.js';
    script.async = true;
    document.head.appendChild(script);

    script.onload = () => {
      if (window.EmbedSocialHashtag) {
        window.EmbedSocialHashtag.load();
      }
    };

    return () => {
      const embedsocialElements = document.querySelectorAll('.embedsocial-hashtag');
      embedsocialElements.forEach(el => el.innerHTML = '');
    };
  }, []);

  return (
    <Box
      className="embedsocial-hashtag"
      data-ref="45808bc53d941bdc2a6efb7e39b35bdaa1b2db8c"
    />
  )
}
